import { render, staticRenderFns } from "./treeTabs.vue?vue&type=template&id=d9010f46"
import script from "./treeTabs.vue?vue&type=script&lang=js"
export * from "./treeTabs.vue?vue&type=script&lang=js"
import style0 from "./treeTabs.vue?vue&type=style&index=0&id=d9010f46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports